import { useEffect, useState } from "react";
import { http } from "../../lib/api";

export default function SubscribersTab() {
  const [data, setData] = useState({ total: 0, last_30d: 0, subscribers: [] });
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await http.get("/admin/subscribers");
      setData(data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("¿Eliminar suscriptor?")) return;
    await http.delete(`/admin/subscribers/${id}`);
    await load();
  };

  const exportCsv = () => {
    const header = "email,name,country,source,created_at\n";
    const rows = data.subscribers.map((s) =>
      [s.email, (s.name || "").replace(/,/g, " "), s.country || "", s.source || "", s.created_at].join(",")
    ).join("\n");
    const blob = new Blob([header + rows], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `politicareal-suscriptores-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const filtered = filter
    ? data.subscribers.filter((s) =>
        (s.email || "").toLowerCase().includes(filter.toLowerCase()) ||
        (s.name || "").toLowerCase().includes(filter.toLowerCase()) ||
        (s.country || "").toLowerCase().includes(filter.toLowerCase()))
    : data.subscribers;

  return (
    <div data-testid="admin-subscribers-tab" className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="font-serif-display text-2xl">
          Suscriptores · <span className="text-rojo">{data.total}</span>
          <span className="ml-3 font-mono text-[12px] uppercase tracking-widest text-sub">
            +{data.last_30d} en 30 días
          </span>
        </h3>
        <div className="flex gap-2">
          <input
            placeholder="Filtrar por correo, nombre, país"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            className="border border-ink/30 px-3 py-2 text-sm rounded-none bg-transparent w-72"
            data-testid="subs-filter"
          />
          <button
            onClick={exportCsv}
            className="border border-ink px-3 py-2 font-mono text-[11px] uppercase tracking-widest hover:bg-ink hover:text-paper transition-colors"
            data-testid="subs-export"
          >
            Exportar CSV
          </button>
        </div>
      </div>

      <div className="border border-ink bg-paper">
        <table className="w-full text-left text-sm">
          <thead className="bg-ink text-paper sticky top-0">
            <tr>
              <th className="px-3 py-2 font-mono text-[11px] uppercase tracking-widest">Correo</th>
              <th className="px-3 py-2 font-mono text-[11px] uppercase tracking-widest">Nombre</th>
              <th className="px-3 py-2 font-mono text-[11px] uppercase tracking-widest">País</th>
              <th className="px-3 py-2 font-mono text-[11px] uppercase tracking-widest">Origen</th>
              <th className="px-3 py-2 font-mono text-[11px] uppercase tracking-widest">Alta</th>
              <th className="px-3 py-2"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={6} className="px-3 py-4 text-sub">Cargando…</td></tr>
            ) : filtered.length === 0 ? (
              <tr><td colSpan={6} className="px-3 py-4 text-sub">Sin suscriptores aún.</td></tr>
            ) : filtered.map((s) => (
              <tr key={s.id} className="border-t border-rule" data-testid={`sub-row-${s.id}`}>
                <td className="px-3 py-2 font-mono">{s.email}</td>
                <td className="px-3 py-2">{s.name || "—"}</td>
                <td className="px-3 py-2 text-sub">{s.country || "—"}</td>
                <td className="px-3 py-2 text-sub">{s.source}</td>
                <td className="px-3 py-2 font-mono text-xs text-sub">{(s.created_at || "").slice(0, 10)}</td>
                <td className="px-3 py-2 text-right">
                  <button
                    onClick={() => remove(s.id)}
                    className="font-mono text-[11px] uppercase tracking-widest text-rojo hover:underline"
                    data-testid={`sub-delete-${s.id}`}
                  >
                    Borrar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
